import { render, staticRenderFns } from "./x-baoJingShuLiang.vue?vue&type=template&id=3403b07c&scoped=true"
import script from "./x-baoJingShuLiang.vue?vue&type=script&lang=js"
export * from "./x-baoJingShuLiang.vue?vue&type=script&lang=js"
import style0 from "./x-baoJingShuLiang.vue?vue&type=style&index=0&id=3403b07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403b07c",
  null
  
)

export default component.exports